import { render } from "./TrashedCheckbox.vue?vue&type=template&id=4e7c2692"
import script from "./TrashedCheckbox.vue?vue&type=script&lang=js"
export * from "./TrashedCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TrashedCheckbox.vue"]])

export default __exports__